export const useLazyAccountClosureStore = async () => {
	const { useAccountClosureStore } = await import('@stores/account-closure');
	return useAccountClosureStore();
};

export const useLazyAccountSetupChecklistStore = async () => {
	const { useAccountSetupChecklistStore } = await import('@stores/account-setup-checklist');
	return useAccountSetupChecklistStore();
};

export const useLazyAccreditationStore = async () => {
	const { useAccreditationStore } = await import('@stores/accreditation');
	return useAccreditationStore();
};

export const useLazyAdvisorStore = async () => {
	const { useAdvisorStore } = await import('@stores/advisor');
	return useAdvisorStore();
};

export const useLazyAutoInvestStore = async () => {
	const { useAutoInvestStore } = await import('@stores/auto-invest');
	return useAutoInvestStore();
};

export const useLazyCustomPlansStore = async () => {
	const { useCustomPlansStore } = await import('@stores/custom-plans');
	return useCustomPlansStore();
};

export const useLazyEmailStore = async () => {
	const { useEmailStore } = await import('@stores/email');
	return useEmailStore();
};

export const useLazyInvestmentEntityStore = async () => {
	const { useInvestmentEntityStore } = await import('@stores/investment-entity');
	return useInvestmentEntityStore();
};

export const useLazyInvestmentGoalsStore = async () => {
	const { useInvestmentGoalsStore } = await import('@stores/investment-goals');
	return useInvestmentGoalsStore();
};

export const useLazyInvestStore = async () => {
	const { useInvestStore } = await import('@stores/invest');
	return useInvestStore();
};

export const useLazyIpoStore = async () => {
	const { useIpoStore } = await import('@stores/ipo');
	return useIpoStore();
};

export const useLazyIraStore = async () => {
	const { useIraStore } = await import('@stores/ira');
	return useIraStore();
};

export const useLazyLoginStore = async () => {
	const { useLoginStore } = await import('@stores/login');
	return useLoginStore();
};

export const useLazyModularDashboardStore = async () => {
	const { useModularDashboardStore } = await import('@stores/modular-dashboard');
	return useModularDashboardStore();
};

export const useLazyPerformancePortfolioStore = async () => {
	const { usePerformancePortfolioStore } = await import('@stores/performance-portfolio');
	return usePerformancePortfolioStore();
};

export const useLazyPlansStore = async () => {
	const { usePlansStore } = await import('@stores/plans');
	return usePlansStore();
};

export const useLazyRedemptionRequestStore = async () => {
	const { useRedemptionRequestStore } = await import('@stores/redemption-request');
	return useRedemptionRequestStore();
};

export const useLazyRiaUpgradeStore = async () => {
	const { useRiaUpgradeStore } = await import('@stores/ria-upgrade');
	return useRiaUpgradeStore();
};

export const useLazyTaxStore = async () => {
	const { useTaxStore } = await import('@stores/tax');
	return useTaxStore();
};

export const useLazyUserStore = async () => {
	const { useUserStore } = await import('@stores/user');
	return useUserStore();
};
